const sliderSettings = {
  infinite: false,
  arrows: true,
  prevArrow: '<div class="collectionRaw__prevArrow"><div class="collectionRaw__prevArrowLineFirst"></div><div class="collectionRaw__prevArrowLineSecond"></div></div>',
  nextArrow: '<div class="collectionRaw__nextArrow"><div class="collectionRaw__nextArrowLineFirst"></div><div class="collectionRaw__nextArrowLineSecond"></div></div>',
  slidesToShow: 3.6,
  slidesToScroll: 1,
  rows: 0,
  responsive: [
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 1.22,
        arrows: false
      }
    }
  ]
};

document.addEventListener('DOMContentLoaded', function() {
  $('.collectionRaw__productsWrapper').each(function(index, gallery) {
    $(this).on('init', function (event, slick) {
      changeProgressBar(slick, 0, this);
    })
  });

  $('.collectionRaw__productsWrapper').each(function() {
    $(this).slick(sliderSettings)
  });

  $('.collectionRaw__productsWrapper').each(function(index, gallery) {
    $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      changeProgressBar(slick, nextSlide, this);
    })
  });


  function changeProgressBar(slick, nextSlide) {
    let calc = ((nextSlide + 1) / (slick.slideCount - 2)) * 100;
    let progressBar = $('.collectionRaw__progress');

    if(window.outerWidth <= 960) {
      calc = ((nextSlide + 1) / (slick.slideCount)) * 100;
    }

    progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
  }

  function changeProgressBar(slick, nextSlide, slider) {
    let calc = ((nextSlide + 1) / (slick.slideCount - 2)) * 100;
    let progressBar = $(slider).next();

    if(window.outerWidth <= 960) {
      calc = ((nextSlide + 1) / (slick.slideCount)) * 100;
    }

    progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
  }
});